import React, { useCallback, useMemo, useState } from 'react'
import compose from 'recompose/compose'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { useDropzone } from 'react-dropzone'
import { withI18n } from '../../hocs'
import ActionDialog from '../action-dialog'
import { tokens } from '../../../assets/tokens'
import * as S from './styled'

const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

const ModalChangeAvatar = ({ open, handleClose, i18n, onSubmit }) => {
  const [imageBase64, setImageBase64] = useState(null)

  const onClickSubmit = e => {
    e && e.preventDefault()
    // Devuelve la petición del padre para que ActionDialog muestre el spinner hasta la respuesta
    return onSubmit && imageBase64 ? onSubmit(imageBase64) : undefined
  }

  const onDrop = useCallback(acceptedFiles => {
    const file = _.first(acceptedFiles)
    toBase64(file)
      .then(base64 => setImageBase64(base64))
      .catch(() => setImageBase64(null))
  }, [])
  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({ onDrop })

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragActive, isDragReject, isDragAccept]
  )

  return (
    <ActionDialog
      open={open}
      title={i18n.modalChangeAvatar.title}
      onClose={handleClose}
      onConfirm={onClickSubmit}
      cancelLabel={i18n.dialog.decline}
      confirmLabel={i18n.modalChangeAvatar.submit}
    >
      <S.Body>
        <S.Label>{i18n.modalChangeAvatar.info}</S.Label>
        <div {...getRootProps({ style })}>
          <input {...getInputProps()} />
          <p>{isDragActive ? i18n.modalChangeAvatar.dropFilesActive : i18n.modalChangeAvatar.dropFilesHere}</p>
        </div>
        {imageBase64 && <S.Preview src={imageBase64} alt="preview" />}
      </S.Body>
    </ActionDialog>
  )
}

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '32px',
  borderWidth: 1.5,
  borderRadius: 8,
  borderColor: tokens.color.border.default,
  borderStyle: 'dashed',
  backgroundColor: tokens.color.background.surface,
  color: tokens.color.text.tertiary,
  outline: 'none',
  cursor: 'pointer',
  transition: 'border .24s ease-in-out'
}

const activeStyle = {
  borderColor: tokens.color.text.secondary
}

const acceptStyle = {
  borderColor: tokens.color.success.main
}

const rejectStyle = {
  borderColor: tokens.color.error.main
}

ModalChangeAvatar.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  i18n: PropTypes.object.isRequired,
  onSubmit: PropTypes.func
}

const enharce = compose(withI18n)

export default enharce(ModalChangeAvatar)
